export type AccountUserRole =
  | "OWNER"
  | "ADMIN"
  | "MANAGER"
  | "WORKER"
  | "VIEWER";

export function isAccountUserRole(value: string): value is AccountUserRole {
  return (
    value === "OWNER" ||
    value === "ADMIN" ||
    value === "MANAGER" ||
    value === "WORKER" ||
    value === "VIEWER"
  );
}

export type PersonSeatState =
  | "UNASSIGNED"
  | "INVITED"
  | "ACTIVE"
  | "SUSPENDED"
  | string;

export interface PersonSeatAssignment {
  personId: string;
  displayName: string;
  preferredName: string | null;
  email: string | null;
  userId: string | null;
  role: AccountUserRole | null;
  membershipStatus: string | null;
  state: PersonSeatState;
  invitationId: string | null;
  invitationExpiresAt: Date | null;
}

export interface PendingAccountInvitation {
  invitationId: string;
  email: string;
  role: string;
  personId: string | null;
  createdAt: Date;
  expiresAt: Date;
}

export interface AccountSeatOverview {
  accountId: string;
  purchasedSeats: number;
  activeSeats: number;
  freeSeats: number;
  persons: PersonSeatAssignment[];
  pendingInvitations: PendingAccountInvitation[];
}

export interface InviteAccountUserCommand {
  email: string;
  role: AccountUserRole;
}

export interface InviteAccountUserResult {
  email: string;
  role: AccountUserRole;
  personId: string | null;
  expiresAt: Date;
  acceptUrl?: string | null;
}

export interface GrantPersonAccessCommand {
  personId: string;
  email: string;
  role: AccountUserRole;
}

export interface GrantPersonAccessResult {
  email: string;
  role: AccountUserRole;
  personId: string | null;
  expiresAt: Date;
  acceptUrl?: string | null;
}

export interface RemovePersonSeatCommand {
  personId: string;
}

export interface RemovePersonSeatResult {
  personId: string;
  userId: string;
  role: AccountUserRole;
  activeSeatsAfter: number;
}

export interface RestorePersonSeatCommand {
  personId: string;
}

export interface RestorePersonSeatResult {
  personId: string;
  userId: string;
  role: AccountUserRole;
  activeSeatsAfter: number;
}

export interface ChangeAccountUserRoleCommand {
  userId: string;
  desiredRole: AccountUserRole;
}

export interface ChangeAccountUserRoleResult {
  userId: string;
  role: AccountUserRole;
}
